export enum ConfirmEmailKeys {
  uid = 'uid',
  email = 'email',
  otp = 'otp',
}

export interface ConfirmEmail {
  [ConfirmEmailKeys.email]: string;
  [ConfirmEmailKeys.otp]: string;
  [ConfirmEmailKeys.uid]: string;
}
